module.exports = __webpack_public_path__ + "static/media/becomePartner.7b548ac6.png";